import { InjectionToken, makeEnvironmentProviders } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

export const SANDBOXED_WEB_COMPONENT_IFRAME_SRC = new InjectionToken<SafeResourceUrl>(
  'SANDBOXED_WEB_COMPONENT_IFRAME_SRC',
);

export const provideSandboxedWebComponentIframeSrc = (src: string) =>
  makeEnvironmentProviders([
    {
      provide: SANDBOXED_WEB_COMPONENT_IFRAME_SRC,
      deps: [DomSanitizer],
      useFactory: (domSanitizer: DomSanitizer) => domSanitizer.bypassSecurityTrustResourceUrl(src),
    },
  ]);
